import { AttractionQRCodeSendingStatus, EventStatusTypes, GroupStatusTypes, OrderStatusKey } from "interfaces";
import { twMerge } from "tailwind-merge";

interface TagProps {
  text: string;
  type?: EventStatusTypes | GroupStatusTypes | OrderStatusKey | AttractionQRCodeSendingStatus | "green" | "pink" | "blue" | "yellow";
  customClassName?: string;
}

export const Tag = ({ text, type = EventStatusTypes.UNKNOWN, customClassName }: TagProps) => {

  const colorClassNames = (type: EventStatusTypes | GroupStatusTypes | OrderStatusKey | AttractionQRCodeSendingStatus | "green" | "pink" | "blue" | "yellow") => {
    if (type === EventStatusTypes.CLOSED || type === GroupStatusTypes.CLOSED || type === GroupStatusTypes.CANCELED || type === OrderStatusKey.FAILED || type === "pink") {
      return "bg-pink-100 ring-pink-100 text-pink-700"
    } else if (type === EventStatusTypes.SELLING || type === GroupStatusTypes.OPENING || type === OrderStatusKey.REFUNDED || type === "yellow") {
      return "bg-yellow-100 ring-yellow-100 text-yellow-700"
    } else if (type ===  EventStatusTypes.COMING || type === GroupStatusTypes.SENDPAYMENT || type === AttractionQRCodeSendingStatus.WAITING || type === OrderStatusKey.PENDING) {
      return "bg-violet-100 ring-violet-100 text-violet-700"
    } else if (type === GroupStatusTypes.SUCCESS || type === OrderStatusKey.SUCCESSFUL || type === AttractionQRCodeSendingStatus.SENT || type === "green") {
      return "bg-green-100 ring-green-100 text-green-700"
    } else if (type === "blue") {
      return "bg-magnolia-600 text-brand-500 ring-magnolia-600"
    } else {
      return "bg-magnolia-500 text-neutral-800 ring-magnolia-600" 
    };
  }
  return (
    <span className={twMerge(`max-w-full w-fit min-w-0 inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ring-1 ring-inset whitespace-normal break-words ${colorClassNames(type)}`, customClassName)}>
      <span className="min-w-0 max-w-full break-words">{text}</span>
    </span>
  )
}
